/**
 * Created by Ivan on 03.06.2025
 */

RewardsConfig.LightingRushWelcomeBonus = {
    unlimitedLives: "1 hour"
};

RewardsConfig.LightningRush = [
    {
        boosters: {
            cheap: 1,
            medium: 1,
            expensive: 1,
            before_cheap: 1,
            before_medium: 1,
            before_expensive: 1
        }
    }
];

RewardsConfig.LightningRushOffer = {
    hard: 1400,
    boosters: {
        cheap: 2,
        medium: 1
    }
};

if (cleverapps.config.features.includes("energy") && cleverapps.config.type !== "match3") {
    RewardsConfig.LightingRushWelcomeBonus = {
        energy: 200
    };

    RewardsConfig.LightningRush = [
        { energy: 100, hard: 5 }
    ];
}
